import script from "./countDown.vue?vue&type=script&setup=true&lang=js"
export * from "./countDown.vue?vue&type=script&setup=true&lang=js"

import "./countDown.vue?vue&type=style&index=0&id=245d7cac&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-245d7cac"]])

export default __exports__